/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum org_coursera_aws_codebuild_BuildStatus {
  FAILED = "FAILED",
  FAULT = "FAULT",
  IN_PROGRESS = "IN_PROGRESS",
  STOPPED = "STOPPED",
  SUCCEEDED = "SUCCEEDED",
  TIMED_OUT = "TIMED_OUT",
}

export enum org_coursera_payment_transaction_PaymentTransactionActionType {
  CHARGEBACK = "CHARGEBACK",
  PARTIAL_REFUND = "PARTIAL_REFUND",
  PAYMENT = "PAYMENT",
  QUERY = "QUERY",
  REFUND = "REFUND",
  VOID = "VOID",
}

export enum org_coursera_product_BillingCycle {
  ANNUAL = "ANNUAL",
  BIANNUAL = "BIANNUAL",
  MONTHLY = "MONTHLY",
}

export enum org_coursera_workspace_authoring_GraderType {
  NB_GRADER = "NB_GRADER",
  VSCODE_CUSTOM_GRADER = "VSCODE_CUSTOM_GRADER",
  VSCODE_PRECONFIGURED_JAVA = "VSCODE_PRECONFIGURED_JAVA",
}

export enum org_coursera_workspace_authoring_ImagePublishStatus {
  PUBLISHED = "PUBLISHED",
  UNPUBLISHED = "UNPUBLISHED",
  UNPUBLISHED_CHANGES = "UNPUBLISHED_CHANGES",
}

export enum org_coursera_workspace_authoring_WorkspaceImageApplicationType {
  AWS_CLOUD = "AWS_CLOUD",
  CUSTOM = "CUSTOM",
  GEN_AI_SANDBOX = "GEN_AI_SANDBOX",
  JUPYTER_NOTEBOOK = "JUPYTER_NOTEBOOK",
  LINUX = "LINUX",
  RSTUDIO = "RSTUDIO",
  VIRTUAL_BROWSER = "VIRTUAL_BROWSER",
  VSCODE = "VSCODE",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
